import classNames from "classnames";
import { OnHoverTooltip } from '../common';
import { forwardRef, useState } from 'react';
import Highlighter from '../amrPipeline/common/Highlighter';
import { CloManagerLabels } from "./CloManagerLabels";
import { CloManager } from "../../types/state/CloManagersState";

interface Props {
    selected: boolean;
    searchTerm: string;
    cloManager: CloManager;
    onClick: (referenceName: string) => void;
    onFavoriteClick: (referenceName: string, addToFavorite: boolean) => void;
    withAlert: boolean;
}

export const CloManagersNavItem = forwardRef(function CloManagersNavItem({
    selected,
    searchTerm,
    cloManager,
    withAlert,
    onClick,
    onFavoriteClick,
}: Props, ref: React.ForwardedRef<HTMLDivElement>) {
    const [hovered, setHovered] = useState(false);

    const {
        legalName,
        referenceName,
        favorite,
        isUserCompany
    } = cloManager;

    const handleFavoriteClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        onFavoriteClick(referenceName, !favorite);
    };

    return (
        <div
            className={classNames(
                "sidebar-nav-list-item sidebar-nav-list-item-extended",
                { hovered },
                { active: selected }
            )}
            ref={ref}
            onClick={() => onClick(referenceName)}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className="flex-row">
                <OnHoverTooltip overlay={legalName}>
                    <span className={classNames('title', { 'title-with-label': isUserCompany })}>
                        <Highlighter
                            searchWords={[searchTerm]}
                            autoEscape={true}
                            textToHighlight={legalName}
                        />
                    </span>
                </OnHoverTooltip>
                {isUserCompany && <span className="bwic-state-my">MY</span>}
            </div>
            <div className="flex-row sidebar-controls">
                <CloManagerLabels
                    showAlertSection
                    isAlertOn={withAlert}
                    manager={cloManager}
                    onFavoriteClick={handleFavoriteClick}
                    showFavoriteIcon
                />
            </div>
        </div>
    );
});
